import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ProductState } from './filtered-community-product.reducer';
import { AppState } from '../app.state';

// Feature selector for the ProductState
export const selectProductState = createFeatureSelector<AppState, ProductState>('filteredProducts');



// Selector for filtered products
export const selectFilteredCommunityProducts = createSelector(
  selectProductState,
  (state: ProductState) => state.filteredProducts
);

// Selector for loading state
export const selectFilteredCommunityProductsLoading = createSelector(
  selectProductState,
  (state: ProductState) => state.loading
);

// Selector for error state
export const selectFilteredCommunityError = createSelector(
  selectProductState,
  (state: ProductState) => state.error
);
